// import React from "react";
// import { StoryNode } from "../../../../CommonUI/StoryBook/StoryData";
// import {FlowConfiguration} from "../../../../Common/Flow/FlowConfiguration";
// import {FormStep} from "../../../../Common/Flow/Steps/UI/FormStep";
// import {XStackContainer} from "../../../../Form/Containers";
// import {ButtonFormControl} from "../../../../Form/Controls/Web/ButtonFormControl";
// import {LinkFormControl} from "../../../../Form/Controls/Web/LinkFormControl";
// import {LinkControlType} from "../../../../Form/Utilities/FormDesignConstants";
// import {FlowBuilder} from "../../../FlowBuilder";

export const FlowBuilderFormStepsStories = [
    // new StoryNode(
    //     () => {
    //         let flow = new FlowConfiguration();
    //         let formStep = new FormStep();
    //
    //         const container = new XStackContainer();
    //
    //         let button = new ButtonFormControl();
    //         button.label = "Ok";
    //         container.add(button);
    //         let link = new LinkFormControl();
    //         link.label = "Cancel";
    //         link.type = LinkControlType.ACTION;
    //         container.add(link);
    //
    //         formStep.executable.add(container);
    //
    //         flow.sequences[0].addStep(formStep);
    //         return <FlowBuilder flow={flow} />;
    //     },
    //     "Flow Builder",
    //     "Designer",
    //     "Form Steps",
    //     "Default"
    // ),
];
